//
// Module for the Employer Reporting Maintenance Detail view
//
rs.module("content/employer/reporting/maintenance/detail",

    [ /* Dependencies */],

    function () {

        // Initialize the module
        function initialize(jsSelectors, cssSelectors) {

            // Unpack Js Selectors
            var header = $.js(jsSelectors.header);

            var headerHistoryContainer = header.js(jsSelectors.headerHistoryContainer);
            var headerHistoryPanel = header.js(jsSelectors.headerHistoryPanel);

            // show/hide batch status history on hover with intent
            // TODO: leverage visibility module for this, once hover popups are normalized
            headerHistoryContainer.hoverIntent({
                handlerOver: function (event) {
                    headerHistoryPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function (event) {
                    headerHistoryPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);